import yup from '../../../../config/yup';

export const copyFileTaskValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('sftpOperation'),
  function: yup.string().default('copyFile'),
  parameters: yup.object().shape({
    credentials: yup.string(),
    port: yup.string(),
    source: yup.string(),
    target: yup.string(),
    result: yup.string(),
  }),
});
